<div class="section">
    <div class="container">
        <div class="header">
            <div>
                <img class="logo" src="./assets/logo.png" alt="" srcset="">
            </div>
            <div class="header-menu">
                <ul *ngIf="user">
                    <li  (click)="toggleMenu($event)">
                        <svg class="icon icon-user">
                            <use xlink:href="./assets/symbol-defs.svg#icon-user"></use>
                        </svg>
                        <div class="user">
                            {{user.first_name}} {{user.last_name}}
                        </div>
                        <ul class="menu hidden" #headermenu >
                            <!--
                                <li>
                                    <svg class="icon icon-chevron-right">
                                        <use xlink:href="assets/symbol-defs.svg#icon-chevron-right"></use>
                                    </svg>
                                     <a routerLink="/home/me">Mein Profil</a>
                                </li>
                                -->
                                <li>
                                    <svg class="icon icon-chevron-right">
                                        <use xlink:href="assets/symbol-defs.svg#icon-chevron-right"></use>
                                    </svg>
                                    <a (click)="changePassword()">Passwort ändern</a>
                                </li>
                            </ul>
                    </li>
                    <li>
                        <svg class="icon icon-log-out">
                            <use xlink:href="./assets/symbol-defs.svg#icon-log-out"></use>
                        </svg>
                        <a (click)="logout()">Ausloggen</a>
                    </li>
                </ul>
                
            </div>
        </div>
    </div>
</div>

<ng-container #modalcontainer></ng-container>
